document.addEventListener('DOMContentLoaded', function () {

    const buttonOpen = document.querySelector(".js-button-open-menu");
    const buttonClose = document.querySelector(".js-button-close-menu");
    const menu = document.querySelector(".js-menu");

    buttonOpen.addEventListener('click', function () {
        menu.classList.add('active');
        buttonOpen.classList.add('hide');
        buttonClose.classList.add('show');
    });

    buttonClose.addEventListener('click', function () {
        menu.classList.remove('active');
        buttonOpen.classList.remove('hide');
        buttonClose.classList.remove('show');
    });

    const links = document.querySelectorAll('.menu-link');
    const headerHeight = 117;

    links.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            const topOffset = targetElement.offsetTop - headerHeight;
            window.scrollTo({
                top: topOffset,
                behavior: 'smooth'
            });
            links.forEach(l => l.classList.remove('active'));
            this.classList.add('active');
        });
    });

    window.addEventListener('scroll', function () {
        let current = '';

        links.forEach(link => {
            const section = document.querySelector(link.getAttribute('href'));
            const sectionTop = section.offsetTop - headerHeight;
            const sectionHeight = section.clientHeight;
            if (window.scrollY >= sectionTop && window.scrollY < sectionTop + sectionHeight) {
                current = link;
            }
        });

        links.forEach(link => link.classList.remove('active'));
        if (current) {
            current.classList.add('active');
        }
    });

    var testimonials = new Swiper(".js-testimonials", {
        slidesPerView: 1,
        spaceBetween: 36,
        autoplay: {
            delay: 4000,
            disableOnInteraction: true
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
    var groups = new Swiper(".js-groups", {
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    const elementsToAnimate = document.querySelectorAll('.animate');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const animElements = entry.target.querySelectorAll('.anim-element');
                animElements.forEach(animElement => {
                    const delay = animElement.getAttribute('data-anim-delay') || 0;
                    setTimeout(() => {
                        animElement.classList.add('animated');
                    }, delay);
                });
                observer.unobserve(entry.target);
            }
        });
    }, {
        rootMargin: '-50% 0px',
        threshold: 0
    });

    elementsToAnimate.forEach(element => {
        const rect = element.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        if (rect.top < windowHeight * 0.5) {
            const animElements = element.querySelectorAll('.anim-element');
            animElements.forEach(animElement => {
                const delay = animElement.getAttribute('data-anim-delay') || 0;
                setTimeout(() => {
                    animElement.classList.add('animated');
                }, delay);
            });
        } else {
            observer.observe(element);
        }
    });

   
   
});